import React from 'react';
import TaskStep from './TaskStep';
import { makeKey } from '../hooks/useConvertForTranslationKey';
const TaskTimeline = _ref => {
  let {
    tasks,
    activeIndex,
    selectedIndex,
    onSelectTask,
    t
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      padding: '0 0.5rem',
      marginBottom: '1.5rem'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: '22px',
      left: 'calc(0.5rem + 22px)',
      right: 'calc(0.5rem + 22px)',
      height: '2px',
      background: '#DBEAFE',
      zIndex: 0
    }
  }), tasks.map((task, index) => /*#__PURE__*/React.createElement(TaskStep, {
    key: task.category_title,
    task: task,
    isActive: index === activeIndex,
    isSelected: index === selectedIndex,
    onClick: () => onSelectTask(index),
    label: t(makeKey(task.category_title))
  })));
};
export default TaskTimeline;